module.exports = __webpack_public_path__ + "media/images/emblems/Felsberg_wappen-0fedca3a842e8d97dff9f97551b78488.svg";